
<section class="ui_pagination">
  <div class="pagination" >
    <ul class="pagination_lists" :style="`justify-content:${horizontalPosition}`">
      <li class="pagination_each" @click="changePage('start')" 
      tabindex="0" @keypress.enter="changePage('start')">&lt;&lt;</li>
      <li class="pagination_each" @click="changePage('prev')"  
      tabindex="0" @keypress.enter="changePage('prev')">&lt;</li>
      <li class="pagination_each" @click="changePage(number)" :class="setActiveClass(number)" v-for="number in pageRange" 
      tabindex="0" @keypress.enter="changePage(number)">{{number}}</li>
      <li class="pagination_each" @click="changePage('next')"
      tabindex="0" @keypress.enter="changePage('next')">&gt;</li>
      <li class="pagination_each" @click="changePage('end')"
      tabindex="0" @keypress.enter="changePage('end')">&gt;&gt;</li>
    </ul>
    <div class="inputPage" v-if="input">
      <div>{{$t('__main.__goToPage')}} :  </div>
      <input type="number" :value="inputValue" @change="onChange"/>
      <div>/ {{totalPage}}</div>
    </div>
  </div>
</section>

